import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { AccountingSide } from "@common/types/domains/accounting/accountingSide";
import { ReportPeriodWithLabel } from "@common/types/reports/types";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { GlTableCallbacks } from "../glDrillDown.lib";
import { TrialBalanceViewRow } from "./trialBalanceViewTypes";
import { TrialBalanceViewValueCell } from "./TrialBalanceViewValueCell";

interface CellFactoryParams {
    period: ReportPeriodWithLabel;
    periodIndex: number;
    kind: AccountingSide;
    firstPeriod: ReportPeriodWithLabel;
}

export function makeTrialBalanceDebitCreditCell({
    period,
    periodIndex,
    kind,
    firstPeriod,
}: CellFactoryParams) {
    const flatIndex = periodIndex * 2 + (kind === AccountingSide.DEBIT ? 0 : 1);

    const Cell: React.FC<
        CellContext<ViewTableFeatures, TrialBalanceViewRow, unknown>
    > = React.memo(({ row, table }) => {
        const onDrillDown = useViewTableMeta<GlTableCallbacks, unknown>(table)
            .callbacks?.onDrillDown;
        return (
            <TrialBalanceViewValueCell
                value={row.original.values[flatIndex] ?? 0}
                accountCode={row.original.accountCode}
                period={period}
                firstPeriod={firstPeriod}
                isSummary={row.original.isSummary}
                onDrillDown={onDrillDown}
            />
        );
    });

    Cell.displayName = `TrialBalance${kind === AccountingSide.DEBIT ? "Debit" : "Credit"}Cell_${periodIndex}`;
    return Cell;
}
